import { addressFormat } from './address-format';

export const Default = {
  validator: null,
  addressFormat,
};
